import { useLayoutEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import "./socialmediaanalysisview.css";

export const baseColors = [
  "#80e4cf",
  "#7949f0",
  "#630163",
  "#b502b1",
  "#e2e2f2",
  "#0ba151"
];

function DFOVolumeAnalysisChart() {
  useLayoutEffect(() => {
    const root = am5.Root.new("dfoVolumeAnalysisChartId");
    root.setThemes([am5themes_Animated.new(root)]);
    if (root._logo) root._logo.dispose();

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        paddingLeft: 0,
        layout: root.verticalLayout
      })
    );

    chart.children.unshift(
      am5.Label.new(root, {
        text: "",
        fontSize: 18,
        fontWeight: "600",
        x: am5.p50,
        centerX: am5.p50,
        paddingTop: 8,
        paddingBottom: 8
      })
    );

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
        marginTop: 8
      })
    );

    const data = [
      { month: "June",      clientDrug1: 100, clientDrug2: 30, competitorDrug1: 40, competitorDrug2: 50, competitorDrug3: 65 },
      { month: "July",      clientDrug1: 90, clientDrug2: 35, competitorDrug1: 48, competitorDrug2: 55, competitorDrug3: 70 },
      { month: "August",    clientDrug1: 100, clientDrug2: 42, competitorDrug1: 52, competitorDrug2: 60, competitorDrug3: 80 },
      { month: "September", clientDrug1: 108, clientDrug2: 40, competitorDrug1: 49, competitorDrug2: 58, competitorDrug3: 75 }
    ];

    const xRenderer = am5xy.AxisRendererX.new(root, {
      cellStartLocation: 0.1,
      cellEndLocation: 0.9,
      minorGridEnabled: true
    });
    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "month",
        renderer: xRenderer,
        tooltip: am5.Tooltip.new(root, {})
      })
    );
    xRenderer.grid.template.setAll({ location: 1 });
    xAxis.data.setAll(data);

    const yRenderer = am5xy.AxisRendererY.new(root, { strokeOpacity: 0.1 });
    const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, { renderer: yRenderer }));
    yAxis.set("numberFormatter", am5.NumberFormatter.new(root, { numberFormat: "#,###" }));
    yAxis.children.unshift(
      am5.Label.new(root, {
        text: "Number of conversations",
        rotation: -90,
        y: am5.p50,
        centerY: am5.p50,
        x: 0,
        centerX: 0,
        paddingRight: 10,
        fontWeight: "500"
      })
    );

    const colorSet = am5.ColorSet.new(root, {
      colors: baseColors.map(hex => am5.color(hex))
    });

    let seriesIndex = 0;
    function makeSeries(name, fieldName) {
      const series = chart.series.push(
        am5xy.ColumnSeries.new(root, {
          name,
          xAxis,
          yAxis,
          valueYField: fieldName,
          categoryXField: "month",
          clustered: true
        })
      );

      const color = colorSet.getIndex(seriesIndex++);
      series.setAll({ fill: color, stroke: color });

      series.columns.template.setAll({
        width: am5.percent(90),
        tooltipY: 0,
        strokeOpacity: 1,
        tooltipText: "{name}, {categoryX}: {valueY.formatNumber('#,###')}"
      });

      series.data.setAll(data);

      series.bullets.push(() =>
        am5.Bullet.new(root, {
          locationY: 0,
          sprite: am5.Label.new(root, {
            text: "{valueY.formatNumber('#,###')}",
            fill: root.interfaceColors.get("alternativeText"),
            centerY: 0,
            centerX: am5.p50,
            populateText: true
          })
        })
      );

      series.appear();
      legend.data.push(series);

      // ✅ Guarded legend marker styling (prevents undefined error)
      const ldi = series.get("legendDataItem");
      if (ldi) {
        ldi.get("marker").setAll({ fill: color, stroke: color });
      }
    }

    makeSeries("Client Drug 1", "clientDrug1");
    makeSeries("Client Drug 2", "clientDrug2");
    makeSeries("Competitor Drug 1", "competitorDrug1");
    makeSeries("Competitor Drug 2", "competitorDrug2");
    makeSeries("Competitor Drug 3", "competitorDrug3");

    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, []);


   return (
    <>
      <p className="chart-sub-text">Comparison of client vs. competitor drug mentions in DFO data across pre congress, live congress, and post congress phases.</p>
      <div id="dfoVolumeAnalysisChartId" className="dfoVolumeAnalysis"></div>
    </>
  )
}

export default DFOVolumeAnalysisChart;